import BaseRepository from "./BaseRepository";
import st from "lib/utils/index";
import { AdminUserDecorator } from "lib/decorators/index";

export default new (class ParticipiantsRepository extends BaseRepository {
  search(order_ids) {
    return this.api.post(`/participants/export`, { order_ids }).map((res) => res.data);
  }
})();



// WEBPACK FOOTER //
// ./src/lib/repositories/ParticipiantsRepository.js